
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eoBBJ", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContext", () => $e386a7914d299870$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $e386a7914d299870$export$5a5baedfe8151ce);

var $gwFzn = parcelRequire("gwFzn");
const $e386a7914d299870$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
function $e386a7914d299870$export$5a5baedfe8151ce() {
    const context = (0, $gwFzn.useContext)($e386a7914d299870$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("gBjFV", function(module, exports) {

$parcel$export(module.exports, "getTrialOfferingName", () => $946849c2df4a87c9$export$38ffae8c634274ba);
const $946849c2df4a87c9$export$38ffae8c634274ba = (edition, config)=>{
    if (edition === 'standard' && config.isPaidStandard) return 'premium';
    return 'standard';
};

});

parcelRegister("ecqMk", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $0a0029952ec94989$export$291d012eb0744b34);
const $0a0029952ec94989$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $0a0029952ec94989$export$291d012eb0744b34 = (product)=>{
    return $0a0029952ec94989$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("b8Yvt", function(module, exports) {

$parcel$export(module.exports, "useConfig", () => $d5b5285bd1f76545$export$b3611e87cd5ba6ce);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
function $d5b5285bd1f76545$export$b3611e87cd5ba6ce(product, edition) {
    return (0, $gwFzn.useMemo)(()=>{
        if (product === 'jira-product-discovery') {
            if (edition === 'free') return {
                shouldSkip: (0, $dh538.fg)('jpd_disable_edition_awareness'),
                warnOnUserLimit: (0, $dh538.fg)('new_ea_jira_product_discovery_free'),
                shouldCheckBillingAdmin: false
            };
            else if (edition === 'standard' || edition === 'premium') return {
                shouldSkip: (0, $dh538.fg)('jpd_disable_edition_awareness')
            };
        }
        if (product === 'jira') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: (0, $dh538.fg)('new_ea_jira_free_modal_refresh'),
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $dh538.fg)('jira_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $dh538.fg)('edition_awareness_upsell_jira_fg'),
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
        }
        if (product === 'jira-service-management') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: (0, $dh538.fg)('new_ea_jira_service_management_free')
            };
            if (edition === 'standard') return {
                isPaidStandard: (0, $dh538.fg)('edition_awareness_upsell_jsm_fg')
            };
        }
        if (product === 'confluence') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $dh538.fg)('connie_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $dh538.fg)('edition_awareness_standard_upsell_confluence_ab_fg'),
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal'),
                shouldCheckReverseTrial: (0, $dh538.fg)('new_ea_confluence_reverse_trial')
            };
        }
        // Default return for other products and editions
        return {};
    }, [
        product,
        edition
    ]);
}

});

parcelRegister("iW8ja", function(module, exports) {

$parcel$export(module.exports, "useSpotlight", () => $b45d16ed15e9cbf0$export$cc7026713a353975);

var $gwFzn = parcelRequire("gwFzn");
function $b45d16ed15e9cbf0$export$cc7026713a353975() {
    const [isSpotlightActive, setIsSpotlightActive] = (0, $gwFzn.useState)(false);
    const handleSetSpotlight = (0, $gwFzn.useCallback)((isActive)=>{
        setIsSpotlightActive(isActive);
    }, [
        setIsSpotlightActive
    ]);
    return {
        isSpotlightActive: isSpotlightActive,
        handleSetSpotlight: handleSetSpotlight
    };
}

});

parcelRegister("ac7kz", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $2a8aa1aaafc441a7$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $2a8aa1aaafc441a7$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $2a8aa1aaafc441a7$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $2a8aa1aaafc441a7$export$e955abb82869dc84);

var $gwFzn = parcelRequire("gwFzn");

var $3pfAb = parcelRequire("3pfAb");

var $6v6KC = parcelRequire("6v6KC");
var $inPa6 = parcelRequire("inPa6");

var $c6GJD = parcelRequire("c6GJD");

var $eoBBJ = parcelRequire("eoBBJ");
const $2a8aa1aaafc441a7$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $2a8aa1aaafc441a7$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $2a8aa1aaafc441a7$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $2a8aa1aaafc441a7$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $eoBBJ.useEditionAwareness)();
    const experimentMeta = (0, $gwFzn.useMemo)(()=>{
        // I wanted to reference the utility function but,
        // that file imports AtlBrowserStorageLocal which makes the VR tests to fail with timeout, even if is not executed on runtime
        //if (isFreeEduOrOrgSite(editionAwarenessContext)) {
        //Only add the metadata when the site may be eligible for the experiment
        if (editionAwarenessContext.edition === 'free' && (editionAwarenessContext.siteType === 'EDU' || editionAwarenessContext.siteType === 'ORG')) return [
            {
                key: 'offer_edu_org_discount',
                cohort: (0, $c6GJD.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled'),
                siteType: editionAwarenessContext.siteType
            }
        ];
        return [];
    }, [
        editionAwarenessContext
    ]);
    const sendAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            config: editionAwarenessContext.config,
            // Payment properties
            isInvoiceable: editionAwarenessContext.isInvoiceable,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            // Entitlement properties
            isInTeamWorkCollection: editionAwarenessContext.isInTeamWorkCollection,
            // User permissions properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            siteType: editionAwarenessContext.siteType,
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            // Capabilities
            hasDismissedButton: editionAwarenessContext.hasDismissedButton,
            isSpotlightActive: editionAwarenessContext.isSpotlightActive,
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen
        };
        if (payload instanceof (0, $6v6KC.default)) {
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            });
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentMeta
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $2a8aa1aaafc441a7$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $2a8aa1aaafc441a7$export$e955abb82869dc84();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});

parcelRegister("8pzEG", function(module, exports) {

$parcel$export(module.exports, "FeatureExposedAnalytics", () => $12c853e475c615c0$export$b12ce465f015026c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $12c853e475c615c0$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
}

});

parcelRegister("kzWPO", function(module, exports) {

$parcel$export(module.exports, "isEligibleForEduDiscount", () => $ca6ff173d640ef42$export$331edc99898f4a8e);
//import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

var $3Ld4I = parcelRequire("3Ld4I");
const $ca6ff173d640ef42$export$331edc99898f4a8e = (context)=>{
    return $ca6ff173d640ef42$export$f52e80ca0459b360(context) && $ca6ff173d640ef42$export$eb0afc9e31269a96();
};
const $ca6ff173d640ef42$export$f52e80ca0459b360 = (context)=>{
    const { edition: edition, siteType: siteType } = context;
    return edition === 'free' && (siteType === 'EDU' || siteType === 'ORG');
};
const $ca6ff173d640ef42$export$eb0afc9e31269a96 = ()=>{
    // AtlBrowserStorageLocal even if is not executed, by just calling this file fails the VR test,
    //  until we have a fix, we can use the native one
    //AtlBrowserStorageLocal.getItem(PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED) !== 'true'
    try {
        return localStorage.getItem((0, $3Ld4I.PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED)) !== 'true';
    } catch (e) {
        return false;
    }
};

});
parcelRegister("3Ld4I", function(module, exports) {

$parcel$export(module.exports, "PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED", () => $658076bfad0c6daf$export$c5bc624b59af1952);
const $658076bfad0c6daf$export$c5bc624b59af1952 = '__storejs_platform_educational_discount_dismissed';

});


parcelRegister("6T6L4", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $f7f27f2cb492c502$export$4ade6028e006f174);
function $f7f27f2cb492c502$export$4ade6028e006f174({ context: context }) {
    const { config: { isStandardTrialsUserAndStorageLimitBreakersEnabled: isStandardTrialsUserAndStorageLimitBreakersEnabled }, product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, licensedUsers: licensedUsers, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft, storageUsageInGB: storageUsageInGB } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if (product === 'confluence') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && (isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && isInTrial && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("cg1pB", function(module, exports) {

$parcel$export(module.exports, "useOnDismissDialog", () => $39cdbde26d9c73b9$export$566c270c8354ea95);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
const $39cdbde26d9c73b9$export$566c270c8354ea95 = ({ touchpointIntent: touchpointIntent, dialogType: dialogType, dialogId: dialogId, attributes: attributes })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    return (0, $gwFzn.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDialogDismissed',
            attributes: {
                touchpointIntent: touchpointIntent,
                dialogType: dialogType,
                dialogId: dialogId,
                ...attributes
            }
        });
    }, [
        sendAnalyticsEvent,
        touchpointIntent,
        dialogType,
        dialogId,
        attributes
    ]);
};

});

parcelRegister("fVYKU", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPoint", () => $3419347acdf26ff2$export$50a5ec7edfae079b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fAD9L = parcelRequire("fAD9L");

var $7wGk4 = parcelRequire("7wGk4");

var $70Blk = parcelRequire("70Blk");

var $aKQ5r = parcelRequire("aKQ5r");
function $3419347acdf26ff2$export$50a5ec7edfae079b(props) {
    const onError = (0, $70Blk.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fAD9L.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7wGk4.ModalTrigger), {
            ...props,
            onError: onError,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aKQ5r.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("fAD9L", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $71b8fe84901d80f2$export$7c9538f5f3c365e9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");

var $TSbNa = parcelRequire("TSbNa");
const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $gwFzn.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $gwFzn.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $gwFzn.useRef)(1);
    const [modals, setModals] = (0, $gwFzn.useState)([]);
    const modalContext = (0, $gwFzn.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $7UHDa.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("TSbNa", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $645b684711965e78$export$ab57792b9b6974a6);

var $gwFzn = parcelRequire("gwFzn");
const $645b684711965e78$export$ab57792b9b6974a6 = (0, $gwFzn.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("7wGk4", function(module, exports) {

$parcel$export(module.exports, "ModalTrigger", () => $abc57e0f1f470075$export$fb10b32cfe19f1e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6hqbZ = parcelRequire("6hqbZ");

var $10PJn = parcelRequire("10PJn");

var $cQDYl = parcelRequire("cQDYl");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $eyWa4 = parcelRequire("eyWa4");

var $4M6GB = parcelRequire("4M6GB");

var $TSbNa = parcelRequire("TSbNa");

var $7wYo8 = parcelRequire("7wYo8");

var $48FEk = parcelRequire("48FEk");

var $gWF6I = parcelRequire("gWF6I");
const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError }) {
    const { openModal: openModal } = (0, $gwFzn.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const metricName = (0, $gwFzn.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $gwFzn.useCallback)(()=>(0, $6hqbZ.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $gwFzn.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $7UHDa.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $7UHDa.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $10PJn.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("4M6GB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointConfig", () => $a93efc0d5ccefe43$export$dfa96f26176fa91f);

var $bniL1 = parcelRequire("bniL1");

var $hnvzE = parcelRequire("hnvzE");
const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}

});
parcelRegister("bniL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $daaceb6577136851$export$2e2bcd8739ae039);

var $hRAXi = parcelRequire("hRAXi");
var $daaceb6577136851$export$2e2bcd8739ae039 = (0, $hRAXi.default);

});
parcelRegister("hRAXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c667fbdd4db7a90b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fwDOR = parcelRequire("fwDOR");

var $gTh9a = parcelRequire("gTh9a");
var $guKyH = parcelRequire("guKyH");
function $c667fbdd4db7a90b$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $gwFzn.useContext)((0, $guKyH.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gTh9a.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwDOR.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("gTh9a", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $6289dbe1fb51a9ba$export$256c542058532d6f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $6289dbe1fb51a9ba$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $6289dbe1fb51a9ba$var$LazySuspenseContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $6289dbe1fb51a9ba$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($6289dbe1fb51a9ba$var$LazySuspenseContext);
    (0, $gwFzn.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$6289dbe1fb51a9ba$var$DynamicFallback.displayName = 'DynamicFallback';
const $6289dbe1fb51a9ba$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $gwFzn.useState)(null);
    const mountedRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $7UHDa.jsx)($6289dbe1fb51a9ba$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($6289dbe1fb51a9ba$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $6289dbe1fb51a9ba$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$6289dbe1fb51a9ba$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("guKyH", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $1b25440b482e3c89$export$9ba3fe09d15de47b);

var $gwFzn = parcelRequire("gwFzn");
const $1b25440b482e3c89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $gwFzn.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});




parcelRegister("7wYo8", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $68a341f15f9dda7b$export$1ff47f24e06a5d2d);

var $gwFzn = parcelRequire("gwFzn");
const $68a341f15f9dda7b$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $68a341f15f9dda7b$var$TIME_TO_INTENT = 200;
function $68a341f15f9dda7b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad }) {
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $68a341f15f9dda7b$var$PRELOAD_MAX_AGE);
            }, $68a341f15f9dda7b$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});

parcelRegister("48FEk", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $f9885621a7911f5b$export$5d4dc37edd8a3adb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $6hqbZ = parcelRequire("6hqbZ");

var $hNKXO = parcelRequire("hNKXO");

var $4M6GB = parcelRequire("4M6GB");
function $f9885621a7911f5b$export$5d4dc37edd8a3adb({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent, UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    const onError = (0, $gwFzn.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
    }, [
        onErrorLocal,
        id
    ]);
    const FallbackComponent = (0, $gwFzn.useCallback)(({ error: error })=>{
        return errorFallback ? errorFallback({
            error: error
        }) : null;
    }, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
            FallbackComponent: FallbackComponent,
            onError: onError,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(PlaceholderComponent, {
                name: placeholderName ?? 'internal-internal-entry-point-container',
                fallback: fallback,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6hqbZ.EntryPointContainer), {
                    entryPointReference: entryPointReference,
                    props: runtimeProps
                })
            })
        })
    });
}

});
parcelRegister("hNKXO", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $e5b5ac7e446444f2$export$b33b857ad1d9900e);

var $dh538 = parcelRequire("dh538");
const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}

});



parcelRegister("70Blk", function(module, exports) {

$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $e3ebf0d7bad26c5e$export$f2e26e89f653216c);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $e3ebf0d7bad26c5e$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const handleOnError = (0, $gwFzn.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("aKQ5r", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $b0c1c91ea364c712$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $b0c1c91ea364c712$export$1bf8122badfd728c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $izVB4 = parcelRequire("izVB4");

var $yGNI1 = parcelRequire("yGNI1");

var $aH0N4 = parcelRequire("aH0N4");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $i6ukv = parcelRequire("i6ukv");

var $4QwsP = parcelRequire("4QwsP");

var $2ujbw = parcelRequire("2ujbw");

var $ac7kz = parcelRequire("ac7kz");

var $a0hTw = parcelRequire("a0hTw");

var $e2ROq = parcelRequire("e2ROq");
const $b0c1c91ea364c712$var$buttonStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $b0c1c91ea364c712$var$defaultStyles = (0, $ecnYn.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $b0c1c91ea364c712$var$warningStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.warning'
});
const $b0c1c91ea364c712$var$dangerStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.danger'
});
const $b0c1c91ea364c712$var$dismissibleStyles = (0, $ecnYn.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $b0c1c91ea364c712$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $b0c1c91ea364c712$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E56910)";
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aH0N4))), {
            label: "",
            color: color ?? defaultColor
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($yGNI1))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)"
    });
}
const $b0c1c91ea364c712$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $a0hTw.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $i6ukv.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2W0qg.default), {
        ...rest,
        ref: ref,
        xcss: [
            $b0c1c91ea364c712$var$buttonStyles,
            appearance === 'default' && $b0c1c91ea364c712$var$defaultStyles,
            appearance === 'warning' && $b0c1c91ea364c712$var$warningStyles,
            appearance === 'danger' && $b0c1c91ea364c712$var$dangerStyles,
            isDismissible && $b0c1c91ea364c712$var$dismissibleStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b0c1c91ea364c712$var$iconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});
const $b0c1c91ea364c712$export$1bf8122badfd728c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $a0hTw.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $e2ROq.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $i6ukv.LinkButton), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fpGTa.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: [
            $b0c1c91ea364c712$var$buttonStyles,
            appearance === 'default' && $b0c1c91ea364c712$var$defaultStyles,
            appearance === 'warning' && $b0c1c91ea364c712$var$warningStyles,
            appearance === 'danger' && $b0c1c91ea364c712$var$dangerStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b0c1c91ea364c712$var$iconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});

});
parcelRegister("yGNI1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e4382cd4db66693d3c799807338c8cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0684606e163b797c$var$_react = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0684606e163b797c$var$_creditCard = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("i3uiK")));

var $0684606e163b797c$var$_creditcardFilled = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("aRQqo")));
function $0684606e163b797c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0684606e163b797c$var$CreditCardIcon = (props)=>/*#__PURE__*/ $0684606e163b797c$var$_react.default.createElement($0684606e163b797c$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $0684606e163b797c$var$_creditcardFilled.default
    }, props));
$0684606e163b797c$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $0684606e163b797c$var$_default = module.exports.default = $0684606e163b797c$var$CreditCardIcon;

});

parcelRegister("2ujbw", function(module, exports) {

$parcel$export(module.exports, "UiViewedEvent", () => $026520e0abbadaad$export$d0a9edec5c713764);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $026520e0abbadaad$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("a0hTw", function(module, exports) {

$parcel$export(module.exports, "useButtonContent", () => $a9f25d7cdaed579f$export$c810aba6284fa97d);

var $dBxQj = parcelRequire("dBxQj");

var $c6GJD = parcelRequire("c6GJD");

var $dh538 = parcelRequire("dh538");

var $6m14E = parcelRequire("6m14E");

var $eoBBJ = parcelRequire("eoBBJ");

var $kzWPO = parcelRequire("kzWPO");

var $h0D5V = parcelRequire("h0D5V");

var $6T6L4 = parcelRequire("6T6L4");

var $3nVjA = parcelRequire("3nVjA");
// TODO: `licensedUserLimit` should be fetched from the server
const $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $a9f25d7cdaed579f$var$getFreeContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, config: config, licensedUsers: licensedUsers, product: product } = context;
    const limits = $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP[product];
    // Education offer has a higher priority than all the other messages
    if ((0, $kzWPO.isEligibleForEduDiscount)(context) && (0, $c6GJD.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.education-offer",
            defaultMessage: "Education discount"
        }),
        appearance: 'default',
        icon: 'gem',
        isEducationDiscount: true
    };
    if (config.warnOnUserLimit && licensedUsers) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.jpd.no-creators-left",
                defaultMessage: "No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.jpd.limited-creators-left",
                defaultMessage: "Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if (product === 'confluence' && edition === 'free' && licensedUsers && licensedUsers >= 3) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.upgrade",
            defaultMessage: "Upgrade"
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.upgrade",
            defaultMessage: "Upgrade"
        }),
        appearance: 'default',
        icon: 'gem'
    };
}
function $a9f25d7cdaed579f$var$getTrialContent({ context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'gem';
    if (product === 'jira' && (0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue('jira_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.daysLeft",
            defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue('connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.daysLeft",
            defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product)) {
        // Trial Countdown Experiment
        const trialCountdownExperimentEnabled = (0, $3nVjA.isEligibleForTrialCountdown)(context) && (0, $c6GJD.default).getExperimentValue('jira_edition_awareness_trial_countdown', 'isEnabled', false);
        // If trial is 3 days or less, swap the button to the warning state
        if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        // If trial is still in its first half, show trial message instead of trial days left
        const isInFirstHalfOfTrial = Boolean(trialCountdownExperimentEnabled && trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') {
                if (product === 'jira' && isInReverseTrial && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
                    if ((0, $c6GJD.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
                        text: formatMessage({
                            id: "@atlassian/edition-awareness.button.see-plans.not-final",
                            defaultMessage: "See plans"
                        }),
                        appearance: appearance,
                        icon: icon
                    };
                }
                return {
                    text: formatMessage({
                        id: "@atlassian/edition-awareness.button.premium-trial",
                        defaultMessage: "Premium trial"
                    }),
                    appearance: appearance,
                    icon: icon
                };
            }
            if (edition === 'standard') return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.standard-trial",
                    defaultMessage: "Standard trial"
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.daysLeft",
            defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
        }, {
            trialDaysLeft: trialDaysLeft
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$var$getPredunningContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue(product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if ((0, $c6GJD.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.choose-plans.not-final",
                defaultMessage: "Choose a plan"
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.addPaymentDetails",
            defaultMessage: "Add payment details"
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    if (edition === 'free') return $a9f25d7cdaed579f$var$getFreeContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $a9f25d7cdaed579f$var$getTrialContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $a9f25d7cdaed579f$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage
    });
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.upgrade",
            defaultMessage: "Upgrade"
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("6m14E", function(module, exports) {

$parcel$export(module.exports, "getProductForTranslation", () => $8d914a23d1ad963b$export$fd45d905638d9909);
const $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $8d914a23d1ad963b$export$fd45d905638d9909(product) {
    return $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("h0D5V", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $d84b3820568fba5b$export$d58c0da339bf36d9);
function $d84b3820568fba5b$export$d58c0da339bf36d9({ product: product, config: { isPaidStandard: isPaidStandard }, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    return !!([
        'confluence',
        'jira',
        'jira-service-management'
    ].includes(product) && isPaidStandard && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium');
}

});

parcelRegister("3nVjA", function(module, exports) {

$parcel$export(module.exports, "isEligibleForTrialCountdown", () => $b8d85562e0df3326$export$947e3549c8b868b2);
function $b8d85562e0df3326$export$947e3549c8b868b2({ isInTrial: isInTrial, isInPredunning: isInPredunning, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, billingSourceSystem: billingSourceSystem }) {
    return Boolean(isInTrial && !isInPredunning && trialDaysLeft && trialLengthDays && billingSourceSystem === 'CCP');
}

});


parcelRegister("e2ROq", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $6cc51f6f7cb57a0e$export$5eea7bde9861e87b);

var $gwFzn = parcelRequire("gwFzn");

var $6Co6F = parcelRequire("6Co6F");

var $eoBBJ = parcelRequire("eoBBJ");
const $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $6cc51f6f7cb57a0e$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $eoBBJ.useEditionAwareness)();
    const origin = (0, $gwFzn.useMemo)(()=>new (0, $6Co6F.default)({
            product: $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $gwFzn.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});



parcelRegister("aH9Q1", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $da1a55ed1292d791$export$e83743682263315a);

var $2xciB = parcelRequire("2xciB");

var $58Nu8 = parcelRequire("58Nu8");

var $56LFI = parcelRequire("56LFI");
const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("2xciB", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $148a59911478cb25$export$cf6fa0bbcc94b912);
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("58Nu8", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $ba332286d251cd41$export$4fe5fba5bb1d3c09);

var $2X3nY = parcelRequire("2X3nY");
function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("2X3nY", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $39dd57c545107221$export$148e45a6d4b4d65);

var $6hmze = parcelRequire("6hmze");

var $cAXnn = parcelRequire("cAXnn");

var $7Z6yP = parcelRequire("7Z6yP");
function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("6hmze", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $546b0d6600b43919$export$567fc7097e064344);
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}

});

parcelRegister("cAXnn", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $df7beae67697fe3a$export$10dc3edfc20c8ff);
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();

});

parcelRegister("7Z6yP", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $1cfe6d8b66e6a41d$export$3b514faac3ba993c);
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("56LFI", function(module, exports) {

$parcel$export(module.exports, "postTask", () => $d3c226111d006051$export$13c9d02ca54955a3);
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("apw9d")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("apw9d", function(module, exports) {

let $79452d0d9203607d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $79452d0d9203607d$var$load("9G5fi").then(()=>parcelRequire('1xaCx'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});





parcelRegister("cab2i", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $991254190d627578$export$fa00dd5c1a75592f);
function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("04kvJ", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $c2899783eac96921$export$e926676385687eaf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $9x4nt = parcelRequire("9x4nt");

var $4u5NT = parcelRequire("4u5NT");

var $2n68y = parcelRequire("2n68y");
const $c2899783eac96921$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $2n68y.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const onError = (0, $gwFzn.useCallback)((error)=>{
        const interaction = (0, $4u5NT.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $4u5NT.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $4u5NT.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: children
    });
};

});
parcelRegister("2n68y", function(module, exports) {

$parcel$export(module.exports, "useErrorAnalytics", () => $4f61c4f554a2ab1f$export$e2d4523bbccd2343);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $ac7kz = parcelRequire("ac7kz");
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $4f61c4f554a2ab1f$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $4f61c4f554a2ab1f$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$4f61c4f554a2ab1f$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $4f61c4f554a2ab1f$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnError = (0, $gwFzn.useCallback)((error)=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                ...(0, $ac7kz.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                id: id ?? 'unknownErrorId',
                isSLOError: $4f61c4f554a2ab1f$var$isSLOError(error)
            }
        });
        const contextAttributes = (0, $ac7kz.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $ac7kz.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        id,
        product,
        edition
    ]);
    return handleOnError;
}

});


parcelRegister("hdlOO", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $c6c461695454e1be$export$1033c28b5e1c2deb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5RBJ9 = parcelRequire("5RBJ9");
var $2Fndw = parcelRequire("2Fndw");

var $eoBBJ = parcelRequire("eoBBJ");

var $h0D5V = parcelRequire("h0D5V");
function $c6c461695454e1be$export$1033c28b5e1c2deb() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { product: product, isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = context;
    const handleDismissSpotlight = (0, $gwFzn.useCallback)(()=>{
        handleSetSpotlight?.(false);
    }, [
        handleSetSpotlight
    ]);
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context)) {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Fndw.default), {
            children: isSpotlightActive && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5RBJ9.default), {
                actions: [
                    {
                        onClick: handleDismissSpotlight,
                        text: 'Got it'
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready."
                })
            }, target)
        });
    }
    return null;
}

});


//# sourceMappingURL=EditionAwareness.7f036f9a.js.map
